import { __assign } from "tslib";
export var DimeActionType;
(function (DimeActionType) {
    DimeActionType["setDialogState"] = "setDialogState";
    DimeActionType["setConvertedToPaid"] = "setConvertedToPaid";
})(DimeActionType || (DimeActionType = {}));
export var DimeReducer = function (state, action) {
    switch (action.type) {
        case DimeActionType.setConvertedToPaid:
            return __assign(__assign({}, state), { convertedToPaid: action.convertedToPaid });
        case DimeActionType.setDialogState:
            return __assign(__assign({}, state), { dialogState: action.dialogState });
    }
};
//# sourceMappingURL=reducer.js.map